import { ComponentProps } from 'react';
import LeadsTable from 'components/elements/LeadsTable';

const DashboardLeadsTable = ({
  items,
  leadContext,
  isLoading,
  ...props
}: ComponentProps<typeof LeadsTable>) => {
  return (
    <LeadsTable
      items={items}
      leadContext={leadContext}
      isLoading={isLoading}
      {...props}
    />
  );
};

export default DashboardLeadsTable;
